import { ArrowUp, MountainSnow } from "lucide-react";

const NAV = [
  { href: "#services", label: "Services" },
  { href: "#coverage", label: "Coverage" },
  { href: "#quote", label: "Free Quote" },
];

const SERVICE_LIST = [
  "Gutter Cleans",
  "Gutter Repairs",
  "Gutter Replacements",
  "Roof Cleans",
  "Roof Paints",
  "Roof Replacements",
];

export default function Footer() {
  const year = new Date().getFullYear();

  const toTop = (e) => {
    e.preventDefault();
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="border-t border-white/[0.08] bg-[#080C12]">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" data-testid="footer-logo" className="flex items-center gap-3">
              <span className="grid h-9 w-9 place-items-center bg-orange-500 text-[#0B0F17]">
                <MountainSnow className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-sm font-extrabold uppercase tracking-[0.18em] text-slate-100">
                  Total Roof Care
                </span>
                <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-orange-400">
                  Taranaki · NZ
                </span>
              </span>
            </a>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              Owner-operated roof and gutter specialists. Cleans, repairs, replacements, paints —
              done properly, for Taranaki conditions.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="text-sm text-slate-300 transition-colors duration-200 hover:text-orange-400"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="tel:0225477534"
                  className="text-sm text-slate-300 transition-colors duration-200 hover:text-orange-400"
                >
                  Call 022 547 7534
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">Services</p>
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {SERVICE_LIST.map((s) => (
                <li key={s} className="font-mono text-xs uppercase tracking-[0.12em] text-slate-400">
                  {s}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-6 border-t border-white/[0.08] pt-8">
          <p data-testid="footer-copyright" className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
            © {year} Total Roof Care Taranaki · New Plymouth → Hāwera
          </p>
          <button
            type="button"
            data-testid="footer-back-to-top"
            onClick={toTop}
            className="group inline-flex items-center gap-3 border border-white/15 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300 transition-colors duration-300 hover:border-orange-500/60 hover:text-orange-400"
          >
            Back to top
            <ArrowUp className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-1" />
          </button>
        </div>
      </div>
    </footer>
  );
}
